// extracted by mini-css-extract-plugin
export default {"radioGroup":"dh5bR5"};